import { Link } from "gatsby";
import React from "react";
import * as styles from "./SignPostLinks.module.scss";

const SAFE_TEXT_LENGTH = 37;

export interface SignPostLinksProps {
	titleLink: DogsTrust.Link;
	childLinks: DogsTrust.Link[];
}
export const SignPostLinks: React.FC<SignPostLinksProps> = ({
	titleLink,
	childLinks,
}) => {
	const safeGetText = (text: string) =>
		text.length < SAFE_TEXT_LENGTH ? text : `${text.slice(0, 36)}...`;

	return (
		<div className={styles.cardcontainer}>
			<div className={styles.titlelink}>
				<Link className={styles.parentlink} to={titleLink.url}>
					{titleLink.title}
				</Link>
			</div>
			<div className={styles.childlinks}>
				{childLinks.map((link) => (
					<Link key={link.title} className={styles.childlink} to={link.url}>
						{safeGetText(link.title)}
					</Link>
				))}
			</div>
		</div>
	);
};

export default SignPostLinks;
